<template>
  <el-dialog
    :title="isEdit ? '编辑小组' : '新建小组'"
    :visible.sync="dialogVisible"
    width="480px"
    :close-on-click-modal="false"
    append-to-body
    @open="handleOpen"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="90px">
      <el-form-item label="小组名称" prop="teamName">
        <el-input v-model="formData.teamName" placeholder="请输入小组名称" maxlength="50" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="小组类型" prop="teamType">
        <el-select v-model="formData.teamType" style="width: 100%" placeholder="请选择" :disabled="isEdit">
          <el-option label="巡查测试小组" value="task"></el-option>
          <el-option label="维修小组" value="fault"></el-option>
        </el-select>
        <div v-if="isEdit" class="field-tip">编辑时不允许更换小组类型</div>
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="3"
          placeholder="选填"
          maxlength="200"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { teamService } from './team.service';

export default {
  name: 'TeamDialog',
  props: {
    visible: { type: Boolean, default: false },
    teamData: { type: Object, default: null }
  },
  data() {
    return {
      formData: { teamName: '', teamType: 'task', remark: '' },
      rules: {
        teamName: [{ required: true, message: '请输入小组名称', trigger: 'blur' }],
        teamType: [{ required: true, message: '请选择小组类型', trigger: 'change' }]
      },
      submitting: false
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(val) { this.$emit('update:visible', val); }
    },
    isEdit() { return !!this.teamData; }
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
      if (this.isEdit) {
        this.formData = {
          teamName: this.teamData.teamName,
          teamType: this.teamData.teamType,
          remark: this.teamData.remark || ''
        };
      } else {
        this.formData = { teamName: '', teamType: 'task', remark: '' };
      }
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const data = {
          ...(this.isEdit ? { uuid: this.teamData.uuid } : {}),
          ...this.formData
        };
        const request = this.isEdit
          ? teamService.updateTeam(data)
          : teamService.addTeam(data);

        request.then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新建成功');
          this.dialogVisible = false;
          this.$emit('success');
        }).finally(() => {
          this.submitting = false;
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.field-tip {
  font-size: 12px;
  color: #e6a23c;
  margin-top: 4px;
}

::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-form-item__error {
  position: relative;
  top: 0;
  padding-top: 2px;
}
</style>
